import { Component, OnInit, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, NavigationEnd } from '@angular/router';
import { NavController } from '@ionic/angular';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-tab-bar',
  templateUrl: './tab-bar.component.html',
  styleUrls: ['./tab-bar.component.scss'],
  standalone: true,
  imports: [CommonModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class TabBarComponent implements OnInit {
  activeTab: string = '';

  tabs = [
    { name: 'Horarios', icon: 'assets/icon/tab-bar/ico_menu_calendario_blanco.svg', route: '/schedule' },
    { name: 'Recorrido', icon: 'assets/icon/tab-bar/ico_menu_locacion_blanco.svg', route: '/route' },
    { name: 'Mis datos', icon: 'assets/icon/tab-bar/ico_menu_misdatos_blanco.svg', route: '/profile' },
    { name: 'Redes', icon: 'assets/icon/tab-bar/ico_menu_redes_blanco.svg', route: '/social-media' },
    { name: 'Contacto', icon: 'assets/icon/tab-bar/ico_menu_contacto_blanco.svg', route: '/contact' }
  ];

  constructor(private router: Router, private navCtrl: NavController) {}

  ngOnInit() {
    this.setActiveTab();
    
    // Listen to route changes and update active tab
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.setActiveTab();
    });
  }

  setActiveTab() {
    const currentUrl = this.router.url;
    const activeTabItem = this.tabs.find(tab => currentUrl.includes(tab.route));
    this.activeTab = activeTabItem ? activeTabItem.route : '';
  }

  navigateTo(route: string) {
    // Use navigateRoot to prevent page stacking in persistent tab bar
    this.navCtrl.navigateRoot(route);
    this.activeTab = route;
  }

  isActive(route: string): boolean {
    return this.activeTab === route;
  }
}
